var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtichoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE8F60;}\n\t.st1{fill:#1C8079;}\n\t.st2{fill:#A1B7A9;}\n\t.st3{fill:#004137;}\n\t.st4{fill:#B9CFC0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.54,151.06c-4.01,0.98-8.06,2.04-12.23,2.23c-4.13,0.19-8.4-0.53-11.92-2.73 c-0.64-0.38-1.29-0.87-1.59-1.55c-0.3-0.61-0.26-1.29-0.26-1.97c0.04-3.07,0-6.81,0.04-9.88c7.76,0.15,15.78,0.79,23.66,0.72 C116.83,142.51,117.78,147.09,120.54,151.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.72,81.46c0,0,7.34,12.65,4.75,20.57c0,0,6.86-9.91,8.38-14.18L113.72,81.46z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.58,137.01c-0.03,3.1-0.02,6.95-0.05,10.06c-0.01,0.67-0.01,1.36,0.27,1.97c0.32,0.68,0.95,1.15,1.58,1.54 c3.52,2.2,7.81,2.89,11.95,2.7s8.2-1.21,12.22-2.23c-2.8-4.01-3.71-8.6-2.27-13.27"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M148.44,128.16c-3.07,4.05-7.65,6.44-11.43,7.49c-6.02,1.67-12.34,2.16-18.78,2.23 c-7.87,0.08-15.9-0.57-23.66-0.72c-1.44-0.04-2.88-0.04-4.32-0.04c-3.52,0.04-7.08,0.04-10.33-1.21c-5.91-2.27-10.83-5-13.44-10.71 c-2.65-5.79-3.41-15.03-4.73-21.24c2.01,0.34,3.97,0.91,5.87,1.67c-0.72-7.84,0.91-15.1,4.5-22.11c0.23-0.45,0.49-0.95,0.98-1.17 c0.49-0.26,1.14-0.15,1.67,0c1.82,0.49,3.6,1.14,5.3,1.97c1.17-4.66,2.91-9.2,5.22-13.44c1.51-2.73,3.94-5.83,6.74-7.15 c2.12,0.64,3.9,2.23,5.53,4.13c1.36-3.18,5.64-7.38,8.82-8.63c0.42-0.19,0.91-0.34,1.4-0.26c0.49,0.11,0.87,0.45,1.25,0.79 c2.73,2.5,5.56,5.83,7.76,8.82c2.16-1.59,4.43-2.99,6.81-4.2c4.2,4.58,8.1,10.64,10.67,16.28c1.44-0.72,3.07-1.21,4.62-0.79 c2.99,0.79,4.28,4.24,4.96,7.27c1.48,6.81,1.82,15.82,1.44,22.79c0.49-0.23,0.98-0.42,1.48-0.61c0.61-0.23,1.29-0.45,1.89-0.23 c0.72,0.26,1.1,1.02,1.36,1.7C151.92,115.75,151.62,123.92,148.44,128.16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.33,109.73c2.29,3.51,17.38-0.15,18.75-7.16l1.75,6.25c0,0-8.46,4.5-10.21,7.77 c-1.75,3.28-3.73,5.18-3.73,5.18l-2.21-4.42L125.33,109.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.67,109.09c0,0,1.61,1.71-0.79,8c-2.4,6.29-6.4,16.81-26.29,15.89c-19.89-0.91-32.35,0.11-34.87,0.8 c-2.52,0.69-15.02-8.3-21.19-10.3c0,0,1.77,6.69,9.83,11.26c2.92,1.66,12.31,2.9,16.51,3.04c1.83,0.06,6.52-0.23,7.32-0.23 s13.26,0.34,13.26,0.34s11.43,0.23,12.35,0.23s13.26-2.4,13.26-2.4l6.29-2.74l4.08-4.8l2.32-8.12l0.69-4.8L148.67,109.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.79,106.22c5.2,0.1,18.06,6.17,26.64-1.98c0,0-7.43,6.78-8.65,12.34c-1.22,5.56-0.91,2.67-0.91,2.67 l-7.55-7.62L67.79,106.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.79,106.37c0,0,8,5.03,14.25,1.75l-6.86,10.21l-3.35-6.48L100.79,106.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.73,81.99c2.52,2.29,16.69-0.57,16.92-3.66l1.37,0.46l-3.89,6.06l-6.74,6.63l-2.97-1.6L114.73,81.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.22,71.13l7.09,5.6l-6.52,5.6l-7.43,7.2l-4.8,0.57l-8.12-7.09c0,0,5.6,3.54,10.17,1.6 S101.7,74.67,100.22,71.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.72,71.51c0,0,11.01-2.71,13.07-6.71l3,3.78l-0.9,1.83l-4.69,8.69l-4.23-2.02L100.72,71.51z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtichoke);
export default __webpack_public_path__ + "static/media/Artichoke.7fdf45cbba3d53767790cef63dbc22f7.svg";
export { ForwardRef as ReactComponent };